export const appVersion = '0.36.0';
